export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11260.5981d261.jpg";